/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/**
 * The fully gamut of formControls supported by the ticket form. Anyting not included here will not work.
 * Also, if you're here to add a new control, also add to the formBuilder.create in [[TicketFormManager]]
 */
export enum TicketFormControls {
	activityName = 'activityName',
	assignedProjectMember = 'assignedProjectMember',
	responsibleProjectMember = 'responsibleProjectMember',
	customFields = 'customFields',
	dateRequested = 'dateRequested',
	dateRequestedAdapter = 'dateRequestedAdapter',
	externalScheduleId = 'externalScheduleId',
	wbsCode = 'wbsCode',
	livePlanGranularity = 'livePlanGranularity',
	liveCrewSize = 'liveCrewSize',
	liveDurationDays = 'liveDurationDays',
	liveFinish = 'liveFinish',
	liveFinishAdapter = 'liveFinishAdapter',
	liveRole = 'liveRole',
	liveStart = 'liveStart',
	liveStartAdapter = 'liveStartAdapter',
	masterScheduleLink = 'masterScheduleLink',
	location = 'location',
	priority = 'priority',
	requestedByProjectMember = 'requestedByProjectMember',
	varianceComment = 'varianceComment',
	varianceReason = 'varianceReason',
	liveWorkingDays = 'liveWorkingDays',
	liveWorkSchedule = 'liveWorkSchedule',
	milestoneType = 'milestoneType',
	liveStartTime = 'liveStartTime',
	liveFinishTime = 'liveFinishTime',
	liveDurationHours = 'liveDurationHours',
}
